
import React from "react";

export function VanityUrlLoading() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold mb-2">Finding Latest Poll</h2>
        <p className="text-muted-foreground">Please wait while we find the latest poll for this team...</p>
      </div>
    </div>
  );
}
